import React, {
	useState,
	useEffect,
	useImperativeHandle,
	forwardRef,
} from "react";
import Modal from "../Modal";
import Form from "../Form";
import Button from "../Button";
import { validateSchema, isValidate } from "../../lib/validator";
import "./index.less";
const SEARCH_ICON =
	"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACGElEQVRYR82XjXETQQyFtRUAHUAHpgLytgGSCkgqSKiApAJMBSQVEBq4dSpI0gElmArEPI/Wsz7fIZ2Zc9gZj+25XenT7+qSvPBKL6xfXIBSykJEPokIv/l5LSJrEXmyzx0A/j5ojQKUUt6KyFcROQ1IvheRzwB+BfbubBkEKKVQ6XezdnNAVX+bxVXAIqX0qpFGr5wBWE2B2AMw5T+qEFV9SCktAdDKncW9qnqVUvrQPMAUiB0Ac/tjY/kNgGvPolIK93yxffTE+2g4+gC08qMJCimvcD2IewBnHjifbwEs22k94/2Qcz6JCGj3dF23asJBL7jV0QIsReTSBDKZ9mLuAfXy5xuAK+/MFqDSM9tzzqz1g1bXdWtWR9SLLcCkg2N0TRjWAN54VrQh0H+Jf1XU5gEAt9PO6QGZClAzOOS6v4RgUij/nypo+4CIrNhPvQTqP+/1gXeRbjhLJ4yW4E4n5B/eBar61Nxy1wBuPE+0bZh9JKW0iFi/B2AQvIq3tyHDoarLnPPPPoh1PnbPftu+AHDrgQ8CVAhVvR2479veXqejjR6zvJ0PQhDeRMT7od6OowbZzHBunuAgU5cL4XYqq45zVd3MhNUrppQe4bCyHcVKKQQJQ7gAkTgO5EYYYhYAy6MQxGwAUYhZASIQswN4EEcB6EOo6nPOmVXlv5odUgVjZ1ii9h5xAoDj+3EBhsCOFoIxr/wBsFErMP8axLEAAAAASUVORK5CYII=";
const getShortSchema = (schema) => {
	let keys = Object.keys(schema);
	if (!keys.length) return [];
	return [keys[0], schema[keys[0]]];
};
const getRestSchema = (schema) => {
	let [key] = getShortSchema(schema);
	if (!key) return {};
	let keys = Object.keys(schema).filter((k) => k !== key);
	let r = {};
	for (let k of keys) {
		r[k] = schema[k];
	}
	return r;
};
const hasRestSchema = (schema) => {
	let scm = getRestSchema(schema);
	let keys = Object.keys(scm);
	return keys.length ? true : false;
};
const getMainError = (errors) => {
	if (typeof errors !== "object") return "";
	let error = "";
	for (let key in errors) {
		let e = errors[key];
		if (e !== undefined) {
			error = e;
			break;
		}
	}
	return error;
};
const hasRestValues = (schema, fields) => {
	// console.log(schema, fields)
	return Object.keys(schema).some((key) => fields[key]);
	/* let [key] = getShortSchema(schema);
	 let res = { ...fields };
	 if (key) {
	   delete res[key];
	 }
	 let values = Object.values(res).filter((v) => v !== undefined);
	 return values && values.length ? true : false;*/
};
export default forwardRef((props, ref) => {
	const {
		defaultValue = {},
		fields,
		schema,
		onSearch,
		onReset,
		onFieldChange,
		children,
		onChange,
		setTempValue,
		...nextProps
	} = props;
	const [visible, setVisible] = useState(false);
	const [errors, setErrors] = useState({});
	const [state, setState] = useState(defaultValue);
	const [modalPosition, setModalPosition] = useState(["auto", "auto"]);
	const [shortKey, shortSchema] = getShortSchema(schema);
	const restSchema = getRestSchema(schema);
	const mainError = getMainError(errors);
	const onModalClose = () => {
		setVisible(false);
		setState({
			[shortKey]: state[shortKey],
			...fields,
		});
		setErrors({});
	};
	const onSubmit = () => {
		if (isValidate(restSchema, state)) {
			onChange({
				...state,
			});
			onSearch(state).then(() => {
				setErrors({});
				setVisible(false);
			});
		} else {
			setErrors(validateSchema(restSchema, state));
		}
	};
	const onClear = () => {
		setState(defaultValue);
		onReset();
		setErrors({});
	};

	const willSearch = (e) => {
		const { x, y } = e.target.getBoundingClientRect();
		setModalPosition([x, y + 30]);
		setVisible(true);
	};

	useImperativeHandle(ref, () => ({
		doClear: () => {
			onClear();
		},
		setFields: (k, v) => {
			setState({
				...state,
				[k]: v
			})
		}
	}));
	const FirtField = shortSchema ? (
		typeof shortSchema.type === "string"
			? require("../" + shortSchema.type).default
			: shortSchema.type) : null;
	return (
		<div className="TUI-AdvancedFilter">
			{shortSchema && FirtField ? (
				<div className="TUI-AdvancedFilter-Short">
					<span className="TUI-AdvancedFilter-Short-Label">
						{shortSchema.name}:{" "}
					</span>
					<span className="TUI-AdvancedFilter-Short-Value">
						<FirtField
							placeholder={shortSchema.placeholder}
							value={state[shortKey]}
							onChange={(v) =>
								setState({
									...state,
									[shortKey]: v,
								})
							}
							fields={state}
							options={shortSchema.options}
							opts={shortSchema.opts}
						/>
					</span>

					<Button
						className="TUI-AdvancedFilter-Short-Search"
						onClick={onSubmit}
					>
						<img
							src={SEARCH_ICON}
							className="TUI-AdvancedFilter-Short-SearchIcon"
						/>
					</Button>
					{hasRestSchema(schema) ? (
						<>
							<span className="TUI-AdvancedFilter-Divider" />
							<span
								className={[
									"TUI-AdvancedFilter-Filter",
									hasRestValues(restSchema, fields)
										? "TUI-AdvancedFilter-Filtered"
										: "",
								].join(" ")}
								onClick={willSearch}
							>
								高级搜索
							</span>
							<span className="TUI-AdvancedFilter-Reset" onClick={onClear}>
								清空条件
							</span>
						</>
					) : (
						<span className="TUI-AdvancedFilter-Reset" onClick={onClear}>
							清空条件
						</span>
					)}

					{React.Children.count(children) ? (
						<>
							<span className="TUI-AdvancedFilter-Divider" />
							{children}
						</>
					) : null}
				</div>
			) : null}
			<Modal
				destroyOnClose={true}
				maskClosable={true}
				visible={visible}
				footer={null}
				title="高级搜索"
				closable={false}
				onCancel={onModalClose}
				className="TUI-AdvancedFilter-Modal"
				wrapClassName="TUI-AdvancedFilter-Modal_wrap"
				width={424}
				style={{
					left: modalPosition[0],
					top: modalPosition[1],
				}}
				mask={false}
			>
				<Form
					schema={restSchema}
					fields={state}
					onChange={(fields) =>
						setState({
							...state,
							...fields,
						})
					}
					onFieldChange={(k, v) => {
						setState({
							...state,
							[k]: v,
						})
						setTempValue({
							...state,
							[k]: v,
						})
					}
					}
				/>
				<div className="TUI-AdvancedFilter-Submit">
					<Button type="primary" onClick={onSubmit}>
						搜索
					</Button>
					<span className="TUI-AdvancedFilter-MainError">{mainError}</span>
				</div>
			</Modal>
		</div>
	);
});
